<template>
    <div @click="onClick">
        <router-link
            :to="{
                name: pathName,
                params: {
                    itemId: itemId, 
                    mode
                }
            }"
            :class="['a-nav-mode-button', modeClass]"
            type="button"
            tag="button"
        >
            <span>
                {{ $t(title) }}
            </span>
        </router-link>
    </div>
</template>

<script>
import { FAST } from "@/components/organisms/o-tiles-grid-with-scroll/constants";

export default {
    name: "ANavModeButton",
    props: {
        itemId: {
            type: Number,
            required: true
        },
        mode: {
            type: String,
            required: true
        },
        pathName: {
            type: String,
            required: true
        }
    },
    computed: {
        title() {
            return this.mode === FAST
                ? 'ui.popup.fastest_route'
                : 'ui.popup.easy_route';
        },
        modeClass() {
            return this.mode === FAST
                ? 'a-nav-mode-button-fast'
                : 'a-nav-mode-button-easy';
        }
    },
    methods: {
        onClick() {
            this.$emit('onClick');
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>